import UploadFile from "@mui/icons-material/UploadFile";
import { type ReactElement } from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  Avatar,
  Box,
  IconButton,
  Paper,
  Typography,
  styled,
  useTheme,
} from "@mui/material";

import { formatBytes } from "./utils";

import type { Theme } from "@mui/material/styles";

export const FileInfo = styled(Box)(({ theme }: { theme: Theme }) => ({
  paddingLeft: theme.spacing(2),
  display: "flex",
  flex: "1",
  flexDirection: "column",
}));

const FileBox = styled(Paper)(({ theme }: { theme: Theme }) => ({
  padding: theme.spacing(2),
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  cursor: "pointer",
}));

interface CensusDropzoneAcceptedFileProps {
  file: File;
  onDelete?: () => void;
}

const CensusDropzoneAcceptedFile = ({
  file,
  onDelete,
}: CensusDropzoneAcceptedFileProps): ReactElement => {
  const theme = useTheme();
  return (
    <FileBox
      elevation={1}
      sx={{
        marginY: theme.spacing(0.5),
      }}
    >
      <Avatar sx={{ bgcolor: theme.palette.surfaces.secondary }}>
        <UploadFile color="brandPrimary" />
      </Avatar>
      <FileInfo>
        <Typography
          variant={"body"}
          color={theme.palette.text.primary}
          sx={{ wordBreak: "break-all" }}
        >
          {file.name}
        </Typography>
        <Typography
          variant={"small"}
          color={theme.palette.text.secondary}
          fontWeight={500}
        >
          {formatBytes(file.size)}
        </Typography>
      </FileInfo>
      <IconButton onClick={() => onDelete?.()}>
        <CloseIcon />
      </IconButton>
    </FileBox>
  );
};

export default CensusDropzoneAcceptedFile;
